import { apiClient } from '@/services/api/apiClient';
import { API_ENDPOINTS } from '@/constants/endpoints';
import {
  // Comment,
  CreateCommentRequest,
  UpdateCommentRequest,
  CreateCommentResponse,
  GetCommentsResponse,
  CommentListParams
} from '@/constants/types';

export const commentService = {
  // Create a new comment
  createComment: async (commentData: CreateCommentRequest): Promise<CreateCommentResponse> => {
    const response = await apiClient.post(API_ENDPOINTS.COMMENTS.CREATE, commentData);
    return response.data;
  },

  // Get comments by feed ID
  getCommentsByFeedId: async (
    feedId: string, 
    params: CommentListParams = {}
  ): Promise<GetCommentsResponse> => {
    const queryParams = new URLSearchParams();
    
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());
    if (params.sort) queryParams.append('sort', params.sort);
    if (params.includeReplies !== undefined) {
      queryParams.append('includeReplies', params.includeReplies.toString());
    }

    const url = `${API_ENDPOINTS.COMMENTS.GET_BY_FEED(feedId)}${
      queryParams.toString() ? `?${queryParams.toString()}` : ''
    }`;
    
    const response = await apiClient.get(url);
    return response.data;
  },

  // Update a comment
  updateComment: async (
    commentId: string, 
    commentData: UpdateCommentRequest
  ): Promise<CreateCommentResponse> => {
    const response = await apiClient.put(
      API_ENDPOINTS.COMMENTS.UPDATE(commentId), 
      commentData
    );
    return response.data;
  },

  // Delete a comment
  deleteComment: async (commentId: string): Promise<{ success: boolean; message: string }> => {
    const response = await apiClient.delete(API_ENDPOINTS.COMMENTS.DELETE(commentId));
    return response.data;
  },
};